import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRechargeManagement = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19997 13.68C7.489 13.6801 6.05116 12.3945 5.8606 10.6942C5.67004 8.99387 6.78763 7.42188 8.45619 7.04327C10.1248 6.66466 11.8114 7.60035 12.3733 9.21641",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3198 10.3201H9.19983V9.20007",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.64 18.16H4.71998C4.10142 18.16 3.59998 17.6586 3.59998 17.04V4.71998C3.59998 4.10142 4.10142 3.59998 4.71998 3.59998H12.6563C12.9533 3.60024 13.238 3.71841 13.4478 3.92851L15.5922 6.0722C15.8022 6.28234 15.9202 6.56732 15.92 6.86442V8.64",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5997 14.7998H20.3997V11.4398",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2594 14.7998C19.7401 12.7876 17.9053 11.3967 15.8276 11.4402C13.7499 11.4837 11.975 12.9503 11.5405 14.9825C11.106 17.0147 12.126 19.079 14.0042 19.9683C15.8824 20.8576 18.1257 20.3386 19.4224 18.7146",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgRechargeManagement);
export default ForwardRef;
